/**
 * This file is part of ONP.
 *
 * Copyright (c) 2014 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Kosova <ivetta.kosova@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/designFacePreview/guideLines/view/abstractView'], function($, AbstractView) {
    return AbstractView.extend({
        renderBleedZone: function(options) {
            options = options || {};

            this.context.strokeStyle = this.bleedZoneColor;
            this._renderOffsetZone(0, 0, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, 0, Math.round(height / 2) + 15);
            }
        },

        renderTrimZone: function(options) {
            options = options || {};
            var widthOffset = Math.round(this.getDeltaWidth(this.zones.trimWidth) / 2);
            var heightOffset = Math.round(this.getDeltaHeight(this.zones.trimHeight) / 2);

            this.context.strokeStyle = this.trimZoneColor;
            this._renderOffsetZone(widthOffset, heightOffset, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, widthOffset, Math.round(height / 2));
            }
        },

        renderSafeZone: function(options) {
            options = options || {};
            var widthOffset = Math.round(this.getDeltaWidth(this.zones.safeWidth) / 2);
            var heightOffset = Math.round(this.getDeltaHeight(this.zones.safeHeight) / 2);

            this.context.strokeStyle = this.safeZoneColor;
            const booklets = [
                'booklets-85x11',
                'booklets-55x85',
                'booklets-a6-portrait',
                'booklets-a6-landscape',
                'booklets-a5-portrait',
                'booklets-a5-landscape',
                'booklets-a4-portrait'
            ];
            options.isBookletPreview = !this.model.has('flipbook') && booklets.indexOf(this.model.get('productSlug')) >= 0;

            this._renderOffsetZone(widthOffset, heightOffset, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, widthOffset, Math.round(height / 2) - 15);
            }
        },

        _renderOffsetZone: function(widthOffset, heightOffset, options) {
            if (options.background) {
                this.context.fillStyle = options.background;
                this.context.fillRect(widthOffset, heightOffset, this.width - widthOffset * 2, this.height - heightOffset * 2);
                if (this.foldingType) {
                    this.textBackground = options.background;
                }
            }

            var width = this.width - widthOffset * 2;
            var height = this.height - heightOffset * 2;
            var isEvenPage = this.model.get('isEvenPage');

            if (
                (options.isBookletPreview && isEvenPage !== undefined) ||
                (this.model.has('flipbook') && this.model.get('flipbook').length > 0 && this.model.get('isVertical'))
            ) {
                height = this.height - heightOffset;

                if (isEvenPage) {
                    heightOffset = 0;
                }
            }

            if (options.isBookletPreview && isEvenPage === undefined) {
                height += 10;
            }

            this.context.strokeRect(widthOffset, heightOffset, width, height);
        }
    });
});
